import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// theme
import { bgGradient } from 'src/theme/css';
// components
import Logo from 'src/components/logo';
import loginImage from 'src/assets/login-image/login.png';
import login from 'src/assets/login-image/theletics-img.png';
import { Grid } from '@mui/material';
// ----------------------------------------------------------------------
type Props = {
  title?: string;
  image?: string;
  children: React.ReactNode;
};
export default function AuthClassicLayout({ children, image, title }: Props) {
  const theme = useTheme();
  const upMd = useResponsive('up', 'md');
  const renderLogo = (
    <Logo
      sx={{
        zIndex: 9,
        position: 'absolute',
        m: { xs: 2, md: 5 },
      }}
    />
  );
  const renderContent = (
    <Stack
      sx={{
        width: 1,
        mx: 'auto',
        my: 'auto',
        maxWidth: 440,
        px: { xs: 2, md: 7 },
        // py: { xs: 15, md: 15 },
      }}
    >
      {children}
    </Stack>
  );
  const renderSection = (
    <Box
      sx={{
        position: 'relative',
        width: '60%',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: 0,
          height: 0,
          borderRight: '60vw solid transparent',
          borderBottom: '100vh solid #5DA5DA',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          right: '50%',
          transform: 'translateX(50%)',
        }}
      >
        <img alt="auth" src={login} style={{ width: '100%', height: 'auto', objectFit: 'cover' }} />
      </Box>
    </Box>
    // </Stack>
  );
  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
      }}
    >
      {upMd && renderSection}
      {renderContent}
    </Stack>
  );
}
